import { i18n } from "@/main";

function getErrorMessage(validation: any): string {
  if (!validation?.$params) return "";
  const key = Object.keys(validation.$params).find((k) => !validation[k]);
  if (key) return i18n.t("validation." + key) as string;
  return i18n.t("error") as string;
}
export { getErrorMessage };
